// Stable display reference derived from the order ID in every role.
// This compact label is not a database identifier; API actions use the full ID.
const orderReference = (value) => {
  const id = value?._id || value;
  if (!id) return '-----';
  const text = String(id);
  let number = 0;
  for (const character of text) {
    number = (number * 31 + character.charCodeAt(0)) % 676000;
  }
  const letters = Math.floor(number / 1000);
  return String.fromCharCode(65 + Math.floor(letters / 26), 65 + letters % 26) +
    String(number % 1000).padStart(3, '0');
};

export { orderReference };
